const brainGameLevels = require('./brainGameLevels');

const { BRAIN_GAME_LEVEL_CONFIG } = brainGameLevels;

const getLocalDayKey = (date = new Date()) => {
    const safeDate = date instanceof Date ? date : new Date(date);
    const resolvedDate = Number.isFinite(safeDate.getTime()) ? safeDate : new Date();
    const month = `${resolvedDate.getMonth() + 1}`.padStart(2, '0');
    const day = `${resolvedDate.getDate()}`.padStart(2, '0');

    return `${resolvedDate.getFullYear()}-${month}-${day}`;
};

const createBrainGameDailyProgress = (date = new Date()) => ({
    date: getLocalDayKey(date),
    games: {},
});

const normalizeGameRunProgress = (progress = {}) => ({
    runs: Math.max(0, Math.round(Number(progress?.runs) || 0)),
    seconds: Math.max(0, Math.round(Number(progress?.seconds) || 0)),
});

const normalizeBrainGameDailyProgress = (rawProgress = {}, date = new Date()) => {
    const today = getLocalDayKey(date);

    if (rawProgress?.date !== today) {
        return createBrainGameDailyProgress(date);
    }

    const games = Object.fromEntries(
        Object.keys(BRAIN_GAME_LEVEL_CONFIG)
            .filter((gameId) => rawProgress?.games?.[gameId])
            .map((gameId) => [gameId, normalizeGameRunProgress(rawProgress.games[gameId])])
    );

    return { date: today, games };
};

const advanceBrainGameDailyProgress = (
    rawProgress,
    gameId,
    elapsedMs = 0,
    date = new Date()
) => {
    const normalizedGameId = `${gameId || ''}`.trim();
    const currentProgress = normalizeBrainGameDailyProgress(rawProgress, date);

    if (!BRAIN_GAME_LEVEL_CONFIG[normalizedGameId]) {
        return currentProgress;
    }

    const currentGameProgress = normalizeGameRunProgress(currentProgress.games[normalizedGameId]);
    const elapsedSeconds = Math.max(0, Math.min(3600, Math.round((Number(elapsedMs) || 0) / 1000)));

    return {
        ...currentProgress,
        games: {
            ...currentProgress.games,
            [normalizedGameId]: {
                runs: currentGameProgress.runs + 1,
                seconds: currentGameProgress.seconds + elapsedSeconds,
            },
        },
    };
};

module.exports = {
    advanceBrainGameDailyProgress,
    createBrainGameDailyProgress,
    getLocalDayKey,
    normalizeBrainGameDailyProgress,
    normalizeGameRunProgress,
};

